/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const MessageSmileSolidV6 = (props) => (
  <Icon {...props} name="Message Smile Solid V6">
    <path d="M13.972 0h-12c-1.102 0-2 .898-2 1.972v8.972c0 1.102.898 1.972 2 1.972h3v2.625c0 .305.352.483.598.303l3.903-2.928h4.5c1.102 0 2-.898 2-1.972V1.972A1.982 1.982 0 0 0 13.972 0zM10 3.5c.555 0 .972.445.972 1s-.445.972-1 .972C9.417 5.472 9 5.056 9 4.5s.447-1 1-1zm-4 0c.555 0 .972.445.972 1s-.416.972-.972.972-1-.416-1-.972.447-1 1-1zm5.322 4.978A4.355 4.355 0 0 1 8 10.001a4.35 4.35 0 0 1-3.319-1.523.75.75 0 0 1 .082-1.055.753.753 0 0 1 1.058.086c.538.628 1.331.991 2.178.991s1.64-.363 2.179-.992a.745.745 0 0 1 1.054-.086.75.75 0 0 1 .088 1.056z" />
  </Icon>
);

export default MessageSmileSolidV6;
